import { render, staticRenderFns } from "./asiakirjat-content.vue?vue&type=template&id=428a891f&scoped=true&"
import script from "./asiakirjat-content.vue?vue&type=script&lang=ts&"
export * from "./asiakirjat-content.vue?vue&type=script&lang=ts&"
import style0 from "./asiakirjat-content.vue?vue&type=style&index=0&id=428a891f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428a891f",
  null
  
)

export default component.exports